import React from 'react';

export const Button = ({ children, variant = 'primary', className = '', loading, ...props }) => {
  const baseClass = `btn-${variant}`;
  return (
    <button className={`${baseClass} ${className}`} disabled={loading} {...props}>
      {loading ? 'Processing...' : children}
    </button>
  );
};
